module.exports = __webpack_public_path__ + "static/media/2.9.5fac23f2.png";